import ReportsIndex from '~/components/pages/reports/Index.vue'

export default [
    {
        path: '/reports',
        name: 'reports.index',
        component: ReportsIndex,
    },
]